var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "#0EC99E",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6004 33.4361L21.5642 18.3991C20.9085 17.7433 19.8453 17.7433 19.1905 18.3991L18.3981 19.1904C17.7423 19.8464 17.7423 20.9096 18.3981 21.5644L33.4343 36.6014C34.0903 37.2572 35.1534 37.2572 35.8082 36.6014L36.5994 35.8101C37.2564 35.1554 37.2564 34.0919 36.6004 33.4361Z",
    fill: "#0EC99E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4342 18.3989L18.3981 33.4361C17.7423 34.0919 17.7423 35.1553 18.3981 35.8101L19.1893 36.6014C19.8453 37.2572 20.9084 37.2572 21.5632 36.6014L36.6003 21.5653C37.2563 20.9095 37.2563 19.8462 36.6003 19.1914L35.8091 18.4002C35.1533 17.7431 34.0902 17.7431 33.4342 18.3989Z",
    fill: "#0EC99E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.d03594e34a862bdb22a2f3b38b3aa0ba.svg";
export { ForwardRef as ReactComponent };